// 客先内示編集において、変更された値を保持するための型定義

/**
 * undo,redoにより変更内容の履歴を管理する項目
 */
export const EditableReceiveAnnounceEventKeyNames = {
  forecast: 'forecast',
  leadTime: 'leadTime',
  standardInventoryIndex: 'standardInventoryIndex',
} as const;
/**
 * 変更内容の履歴を管理する項目を列挙した型
 */
export type EditableReceiveAnnounceEventKeys =
  (typeof EditableReceiveAnnounceEventKeyNames)[keyof typeof EditableReceiveAnnounceEventKeyNames];
/**
 * 変更内容を管理する型
 */
export type EditReceiveAnnounceEvent = { key: EditableReceiveAnnounceEventKeys; beforeValue: any; afterValue: any };
